import { render } from "./PlansPage.vue?vue&type=template&id=8dfe28ce&scoped=true"
import script from "./PlansPage.vue?vue&type=script&lang=js"
export * from "./PlansPage.vue?vue&type=script&lang=js"

import "./PlansPage.vue?vue&type=style&index=0&id=8dfe28ce&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dfe28ce"]])

export default __exports__